
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class QuizSlide extends Vue {
  // Labels
  @Prop() question !:string;
  @Prop() image !:string;
  @Prop() hiddenTitle!: string;
  @Prop() submitLabel!: string;
  @Prop() correctQuestionTitle!: string;
  @Prop() incorrectQuestionTitle!: string;
  @Prop() tryAgainLabel!: string;
  @Prop() quizInstructions!: string;
  @Prop() correctFeedback!: string;
  @Prop() incorrectFeedback!: string;

  // Accessibility Labels
  @Prop() accessibilityQuizInstructions!: string;
  @Prop() accessibilityCorrectFeedback!: string;
  @Prop() accessibilityIncorrectFeedback!: string;
  @Prop() accessibilitySelectFeedback!: string;

  // Quiz Config
  @Prop({default: false}) scorable!: boolean;
  @Prop({default: false}) instantFeedback!: boolean;
  @Prop({default: 'fixed' }) layout?: string;
}
